import { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';

const db = firebase.firestore();

/**
 * Modal for deleting a task template
 * Shows count of all tasks that will be deleted
 * Prevents deletion of active templates
 */
export function DeleteTemplateModal({ template, onClose, onSuccess }) {
  const [totalTaskCount, setTotalTaskCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  const isActive = template.isActive === true;

  useEffect(() => {
    // Count ALL tasks (open and completed) that will be deleted — server count, no docs
    const q = db.collection('tasks').where('templateId', '==', template.id);
    (q.getCountFromServer ? q.getCountFromServer().then(r => r.data().count) : q.get().then(s => s.size))
      .then(count => {
        setTotalTaskCount(count);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [template.id]);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onSuccess();
      onClose();
    } catch (error) {
      // console statement removed for production
      setDeleting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-danger" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vorlage löschen</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        {isActive ? (
          <div className="delete-warning">
            <i className="fas fa-exclamation-triangle"></i>
            <div>
              <p>
                <strong>Aktive Vorlage!</strong> Diese Vorlage ist derzeit aktiviert und generiert automatisch neue Aufgaben.
              </p>
              <p>
                <strong>Sie müssen die Vorlage zuerst deaktivieren</strong>, bevor sie gelöscht werden kann.
              </p>
            </div>
          </div>
        ) : (
          <div className="delete-warning">
            <i className="fas fa-exclamation-triangle"></i>
            <div>
              <p>
                <strong>Achtung!</strong> Diese Aktion löscht die Vorlage permanent.{' '}
                {loading ? 'Zähle Tasks...' : (
                  <>
                    <strong>
                      {totalTaskCount} Aufgabe{totalTaskCount !== 1 ? 'n' : ''}
                    </strong> (offen und erledigt) werden ebenfalls gelöscht.
                  </>
                )}
              </p>
              <p>Diese Aktion kann nicht rückgängig gemacht werden!</p>
            </div>
          </div>
        )}

        <div className="modal-actions">
          <button type="button" onClick={onClose} disabled={deleting}>
            {isActive ? 'Schließen' : 'Abbrechen'}
          </button>
          {!isActive && (
            <button
              type="button"
              className="btn-danger"
              onClick={handleDelete}
              disabled={loading || deleting}
            >
              {deleting ? 'Löscht...' : 'Vorlage löschen'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
